import { IUser } from '../../modules/Auth/models/user.model';

export function isB2BUser(user?: IUser | null, companyName?: string) {
  if (!user) return false;
  if (!companyName) return user.isB2B;

  return user.isB2B && user.B2BCompany === companyName;
}
